import checkDuplicateBuilderKeys from "./check-duplicate-builder-keys.js";
import checkDuplicateFieldKeys from "./check-duplicate-field-keys.js";
import checkRepeaterDepth from "./check-repeater-depth.js";
import checkPluginVersion from "./check-plugin-version.js";
import checkLocales from "./check-locales.js";
import checkField from "./check-field.js";

export default {
	checkDuplicateBuilderKeys,
	checkDuplicateFieldKeys,
	checkRepeaterDepth,
	checkPluginVersion,
	checkLocales,
	checkField,
};
